export async function promiseHandler(promise, data = null) {
  try {
    const result = data ? await promise(data) : await promise();

    return [result, null];
  } catch (error) {
    return [null, error];
  }
}
